var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$store.state.isLogged || _vm.$route.meta.isAlway)?_c('Content'):_vm._e(),_c('GoTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }